import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeWhile} from 'rxjs';
import {UserService} from '../../services/user/user.service';
import {User} from '../../services/user/user';
import {EnableSuppresNotificationsService} from '../../services/enable-suppres-notifications/enable-suppres-notifications.service';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';


@Component({
    selector: 'app-enable-supress-notifications',
    templateUrl: './enable-supress-notifications.component.html',
    styleUrls: ['./enable-supress-notifications.component.css'],
    standalone: false
})
export class EnableSupressNotificationsComponent implements OnInit, OnDestroy {
  @Output() emitResult = new EventEmitter();
  notificationsForm: UntypedFormGroup;
  currentUser: User;
  notificationsList = [
    {key: 'BookShipment', text: 'Book Shipment'},
    {key: '3080Initiate', text: '3080 Initiate'},
    {key: '3080Reminder', text: '3080 Reminder'},
    {key: '3080Completion', text: '3080 Completion'},
  ];
  observer$ = new BehaviorSubject(true);

  constructor(private formBuilder: UntypedFormBuilder, private userService: UserService,
              private enableSuppresNotificationsService: EnableSuppresNotificationsService, private loader: LoadingService,
              private alertService: AlertService) {
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe((currentUser: any) => {
      this.currentUser = currentUser;
    });
  }

  ngOnInit(): void {
    this.fetchAllNotifications();
  }

  fetchAllNotifications() {
    this.loader.show();
    this.enableSuppresNotificationsService.getAllSuppressNotifications().subscribe(res => {
      console.log(res);
      const prefs = res as Array<any>;
      if (prefs && prefs.length > 0) {
        const checkboxGroup = new UntypedFormArray(this.notificationsList.map(item => new UntypedFormGroup({
          id: new UntypedFormControl(item.key),
          text: new UntypedFormControl(item.text),
          checkbox: new UntypedFormControl(this.getSuppressedValue(prefs, item.key) === '1' ? true : false)
        })));
        this.notificationsForm = this.formBuilder.group({
          notifications: checkboxGroup
        });
      } else {
        const checkboxGroup = new UntypedFormArray(this.notificationsList.map(item => new UntypedFormGroup({
          id: new UntypedFormControl(item.key),
          text: new UntypedFormControl(item.text),
          checkbox: new UntypedFormControl(false)
        })));
        this.notificationsForm = this.formBuilder.group({
          notifications: checkboxGroup
        });
      }
      this.loader.hide();
    }, error => {
      this.loader.hide();
      console.log(error);
      this.alertService.error('Error while fetching suppress notification preferences');
    });
  }

  getSuppressedValue(prefList, key) {
    return prefList.filter(x => x.notifyType === key)[0].suppressed;
  }

  savePref() {
    this.loader.show();
    const payLoad = [];
    this.notificationsForm.value.notifications.forEach(notification => {
      payLoad.push({
        userId: this.currentUser.id,
        notifyType: notification.id,
        suppressed: notification.checkbox ? 1 : 0
      });
    });
    this.enableSuppresNotificationsService.updateSuppressNotifications(this.currentUser.id, payLoad).subscribe(res => {
      this.loader.hide();
      this.emitResult.emit('');
      this.alertService.success('Successfully updated suppress notifications');
    }, error => {
      this.loader.hide();
      this.alertService.success('Error occurred while updating suppress notifications. Please contact system admin');
    });
  }

  ngOnDestroy() {
    this.observer$.next(false);
  }

}
